// src/pages/Privacy.js
import React, { useState, useEffect } from 'react';
import "../terms.css"
import UserStatus from './UserStatus';

const Privacy = () => {

useEffect(() => {
  document.title = "Privacy Policy | TradeBarta.com";
}, []);

  return (
    <div className="page-container">
      <div className="content-wrap">
      <section className="navbar-area navbar-one">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <nav className="navbar navbar-expand-lg">
            <a className="navbar-brand" href="/">
              <img width = "200" height = "70" src={require("../images/logo.png")} alt="Logo" />
            </a>

            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarOne"
              aria-controls="navbarOne" aria-expanded="false" aria-label="Toggle navigation">
              <span className="toggler-icon"></span>
              <span className="toggler-icon"></span>
              <span className="toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse sub-menu-bar" id="navbarOne">
              <ul className="navbar-nav m-auto">
                <li className="nav-item">
                  <a className="active page-scroll" href="/">Home</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/pricing">Pricing</a>
                </li>
                
                <li className="nav-item">
                  <a className="page-scroll" href="/referral">Refer and Win</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/faq">FAQ</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/contact">Contact Us</a>
                </li>
                
              </ul>
            </div>
        
          <div className="navbar-btn">
                  <UserStatus />      
          </div>
      </nav>
        </div>
      </div>
    </div>
  </section>
<div
  className="form-container"
  style={{
    maxWidth: '800px',
    margin: '0 auto',
    textAlign: 'left',
    padding: '20px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.05)'
  }}
>
  <h1 style={{marginTop: '130px', marginBottom: '40px', textAlign: 'center' }}>
    Privacy Policy
  </h1>
      <h2>1. Information We Collect</h2>
      <ul>
        <li>Personal details: Name, email, phone</li>
        <li>Account data: login, plan info</li>
        <li>Usage data: stocks tracked, preferences</li>
        <li>Payment info (via third-party payment gateway)</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To deliver stock alerts and news</li>
        <li>To communicate service updates</li>
      </ul>

      <h2>3. Messaging and Notifications</h2>
      <p>Alerts are sent by SMS/Telegram as per your selected plan / preference. You agree to receive these messages by subscribing.</p>

      <h2>4. Data Sharing</h2>
      <p>We only share data with message delivery partners, payment processors, and legal authorities when required.</p>

      <h2>5. Security</h2>
      <p>We use reasonable measures to protect your data</p>

      <h2>6. Data Retention</h2>
      <p>We retain user data as needed for legal and service purposes.</p>

      <h2>8. Third-Party Links</h2>
      <p>We are not responsible for the privacy practices of external sites linked from our platform.</p>

      <h2>9. Changes to This Policy</h2>
      <p>We may revise this policy. Continuing to use our service means you accept those changes.</p>

      <h2>10. Contact</h2>
      <p>Email us at: <a href="mailto:support@tradebarta.com">support@tradebarta.com</a>.</p>
    </div>
    </div>
<section className="footer-area footer-five">
  <div className="container">
    <div className="footer-top-content">
      
      {/* Links Section */}
      <div className="footer-links">
        <ul>
          <li>
            <a href="/terms" target="_blank" rel="noopener noreferrer">
              Terms & Conditions
            </a>
          </li>
          <li>
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </li>
        </ul>
      </div>

      {/* Contact Section */}
      <div className="footer-contact">
        <h4>Contact Us:</h4>
        <a href="mailto:support@tradebarta.com">support@tradebarta.com</a>
      </div>

    </div>
  </div>

  {/* Bottom copyright section */}
  <div className="footer-copyright">
    <div className="container">
      <p className="text-center">Copyright © 2025. All Rights Reserved</p>
    </div>
  </div>
</section>
    </div>
  );
};

export default Privacy;
